import { PayloadAction } from "@reduxjs/toolkit";
import { GetClientMoneyTransactionsByVendorPayload } from "../../../finance/payload/GetClientMoneyTransactionsByVendor/GetClientMoneyTransactionsByVendorPayload";
import { ClientsState } from "../../models/ClientsState";

const getClientMoneyTransactionsByVendorFetch = (state: ClientsState, action: PayloadAction<GetClientMoneyTransactionsByVendorPayload>) => {
    state.isLoading = true;
}

export default getClientMoneyTransactionsByVendorFetch;